import { IncomingMessage, MessageHandler } from '@carvana/merch-native';
import { useContext, useMemo } from 'react';
import GlobalContext from '~/context/home/GlobalContext';
import { useLandedTrackEvent } from '~/hooks/home/telemetry/useSendViewedEvent';
import { ListenerEvent, type ListenerEventType } from './constants';

type ExploreInViewPayload = {};

function isExploreInViewMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, ExploreInViewPayload> {
  return message.event === ListenerEvent.ExploreInView;
}

export default function useIsExploreInViewHandler(): MessageHandler<
  ListenerEventType,
  ExploreInViewPayload
> {
  const landedTrackEvent = useLandedTrackEvent();
  const { setDisplayLowerFoldOnNative } = useContext(GlobalContext);

  return useMemo(
    () =>
      new MessageHandler(isExploreInViewMessage, () => {
        landedTrackEvent(true);
        setDisplayLowerFoldOnNative(true);
      }),
    [landedTrackEvent, setDisplayLowerFoldOnNative]
  );
}
